import { Directive, ElementRef } from '@angular/core'

@Directive({
  selector: '[appConfirmationCarouselSlide]',
})
export default class ConfirmationCarouselSlideDirective {
  constructor(private elementRef: ElementRef<HTMLElement>) {}

  setVisible(visible: boolean): void {
    const element = this.elementRef.nativeElement
    if (visible) {
      element.removeAttribute('inert')
      element.removeAttribute('aria-hidden')
    } else {
      element.setAttribute('inert', '')
      element.setAttribute('aria-hidden', 'true')
    }
  }
}
